import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-45644041__Lager_1",
  "data-name": "Lager 1",
  viewBox: "0 0 243 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-45644041__cls-2{fill:#fbb911}.i-45644041__cls-3{fill:#fff}")
        ])),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<rect width=\"240\" height=\"240\" rx=\"30\" style=\"fill:none;\"></rect><rect width=\"240\" height=\"240\" x=\"3\" class=\"i-45644041__cls-2\" rx=\"30\"></rect><path d=\"M123.33 27.56a92.89 92.89 0 1 0 92.89 92.88 92.87 92.87 0 0 0-92.89-92.88m0 167.79a74.91 74.91 0 1 1 74.91-74.91 74.89 74.89 0 0 1-74.91 74.91\" class=\"i-45644041__cls-3\"></path><circle cx=\"124\" cy=\"120\" r=\"81\" class=\"i-45644041__cls-3\"></circle><path d=\"M105 160.91h4.81v-34.7H105a4.8 4.8 0 0 1-4.8-4.8v-11.48a4.81 4.81 0 0 1 4.8-4.81h26.91a4.81 4.81 0 0 1 4.8 4.81v51h4.81a4.81 4.81 0 0 1 4.8 4.81v11.46a4.8 4.8 0 0 1-4.8 4.8H105a4.8 4.8 0 0 1-4.8-4.8v-11.48a4.81 4.81 0 0 1 4.8-4.81M123.21 59a17.3 17.3 0 1 0 17.3 17.3 17.3 17.3 0 0 0-17.3-17.3\" class=\"i-45644041__cls-2\"></path>", 5))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "info"}) } }